import { Benefits } from '../components/benefits/benefits';
import { GuanteraClient } from '../components/guantera/components/guantera-client/guantera-client';
import { Header } from '../components/header/header';
import { LoaderFeedback } from '../components/loaders/loader-feedback';
import { LoaderSac } from '../components/loaders/loader-sac';
import { MyServices } from '../components/my-services/my-services';
import { Novedades } from '../components/novedades/novedades';
import { StyledSpinner } from '../components/styled-spinner/styled-spinner';
import { UserSection } from '../components/user-section/user-section';
import { VehicleManager } from '../components/vehicle-manager/vehicleManager';
import { Vips } from '../components/vips/vips';
import { DisclaimersProvider } from '../context/disclaimers-context';
import React, { useMemo } from 'react';
import { getAllDisclaimers } from '../helpers/disclaimers/get-all-disclaimers';
import { useDisclaimerReference } from '../hooks/use-disclaimer-reference';
import { useNotificationsBar } from '../components/notifications-bar/hooks/use-notifications-bar';
import { DataCollection, DataVehicles, GetPersonUser, PersonBenefits } from '@esportal/portal-service';
import { NotificationsBar } from '../components/notifications-bar/notifications-bar';
import { PortalContext } from '../context/portal-context';
import { useUniversalEffect } from '@volkswagen-onehub/vw-starter-feature-app-support';
import { usePageTracker } from '../hooks/use-page-tracker';
import { getUserName } from '../helpers/nameHelper';
import { ClubVolkswagenPages, getClubVolkswagenPageInfo } from './model/club-volkswagen-pages-info';

interface DashboardProps {
	personBenefits: PersonBenefits | null;
	userVehicles: DataVehicles | null;
	userData: GetPersonUser | null;
	dataCollection: DataCollection | null;
}

export const DashboardPage = ({ personBenefits, userVehicles, userData, dataCollection }: DashboardProps) => {
	const { pageInfoService } = React.useContext(PortalContext);
	const userName = getUserName(userData);
	const pageInfo = getClubVolkswagenPageInfo(ClubVolkswagenPages.Dashboard, { name: userName });

	useUniversalEffect(() => {
		pageInfoService.setPageInfo({
			seo: { pageTitle: pageInfo.seoTitle },
		});
	}, [pageInfoService]);

	usePageTracker({ contentId: pageInfo.contentId });

	const { notificationBarHeight, isNotificationBarVisible, notificationBarRef, setIsNotificationBarVisible } =
		useNotificationsBar(userData, userVehicles);
	const allDisclaimers = useMemo(() => getAllDisclaimers(personBenefits, userVehicles), [personBenefits, userVehicles]);

	useDisclaimerReference(allDisclaimers);

	return (
		<DisclaimersProvider allDisclaimers={allDisclaimers}>
			<>
				{isNotificationBarVisible && (
					<NotificationsBar
						notificationBarRef={notificationBarRef}
						setIsNotificationBarVisible={setIsNotificationBarVisible}
					/>
				)}
				<VehicleManager userVehicles={userVehicles} notificationBarHeight={notificationBarHeight} />
				<Header />
				{personBenefits ? <Benefits personBenefits={personBenefits} /> : <StyledSpinner variant="x-large" />}
				{userData && userVehicles ? (
					<MyServices vehicles={userVehicles.vehicles} userData={userData} />
				) : (
					<StyledSpinner variant="x-large" />
				)}
				{<GuanteraClient vehicles={userVehicles?.vehicles} />}
				<Novedades />
				<Vips />
				{dataCollection ? <UserSection dataCollection={dataCollection} /> : <StyledSpinner variant="x-large" />}
				<LoaderSac />
				<div id="opina" style={{ marginTop: 'var(--size-dynamic0200)' }}>
					<LoaderFeedback />
				</div>
			</>
		</DisclaimersProvider>
	);
};
